import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';
// * Kendo
import { TreeView } from "@progress/kendo-react-treeview";

// * custom items
import customItem from './customItem';

const TreeViewGA = (props) => {
    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');

    //#region State

    // tree to show - is reduced when a search is performed
    const [treeDataToShow, setTreeDataToShow] = useState([]);
    // is always kept complete
    const [completeTreeData, setCompleteTreeData] = useState([])

    //#endregion

    //#region init tree
    // * The tree is traversed to open the corresponding node.
    useEffect(() => {
        if (props.dataSource) {

            const expandTreeNode = (data) => {
                const defaultOpen = props.defaultOpen ? props.defaultOpen : '';
                data.forEach((item) => {
                    if (item.code === defaultOpen) {
                        item.expanded = true;
                    } else {
                        item.expanded = false;
                    }
                });
                // Sets the json´s state with the expanded node already defined
                setTreeDataToShow(data);
                // Always complete data
                setCompleteTreeData(data);
            }

            expandTreeNode(props.dataSource)
        }
    }, [props.dataSource, props.defaultOpen])
    //#endregion

    //#region handles
    //* This allow us to show as SELECTED the clicked element
    const onItemClick = (event) => {
        if (!event.item.items && !props.blockTree) {
            // Recursive function that allows us to select a node and deselect the others.
            const foo = (item) => {
                // Node with children may not be clickable
                if (item.items) {
                    return {
                        ...item,
                        items: item.items.map(foo)
                    }
                } else {
                    if (item.text === event.item.text) {
                        return {
                            ...item,
                            selected: true
                        }
                    } else {
                        return {
                            ...item,
                            selected: false
                        }
                    }
                }
            }

            // Variable with the new data after recursive function
            const treeDataNew = treeDataToShow.map(foo);

            // State
            setTreeDataToShow(treeDataNew);

            if (!event.item.items && props.afterClickLeaf) {
                // Parent handles what happens to a selected node
                const leafData = {
                    ...event.item
                }
                props.afterClickLeaf(leafData)
            }
        }

    };

    // This allows the control expand
    const onExpandChange = (event) => {
        event.item.expanded = !event.item.expanded;
    };
    //#endregion

    //#region searching
    // ! We use this function to search in the treeview using the input onchange event
    const handleSearch = (event) => {
        //only search if some data exists
        if (completeTreeData.length === 0) return

        let value = event.target.value;

        //parent handles what happens when treeView making a search
        if (props.searchingInTree) {
            props.searchingInTree()
        }

        let newData = search(completeTreeData, value);
        setTreeDataToShow(newData);
    };

    const search = (items, term) => {
        return items.reduce((acc, item) => {
            if (contains(item.text, term)) {
                acc.push(item);
            } else if (item.items && item.items.length > 0) {
                let newItems = search(item.items, term);
                if (newItems && newItems.length > 0) {
                    acc.push({
                        text: item.text,
                        items: newItems,
                        expanded: true,
                    });
                }
            }
            return acc;
        }, []);
    };

    const contains = (text, term) => {
        return text.toLowerCase().indexOf(term.toLowerCase()) >= 0;
    };
    //#endregion

    const getContainerClass = () => {        
        return (props.useWideContainer)? 'treeview_container_wide800' : 'treeview_container';
    }

    return (
        <>
            <div>
                <input className="treeview_search_ipt" onChange={handleSearch} placeholder={t('scenarios.search_placeholder')} />
            </div>
            <div className='treeview_container_container'>
                <div className={getContainerClass()}>
                    <TreeView
                        data={treeDataToShow}
                        item={customItem}
                        expandIcons={true}
                        onExpandChange={onExpandChange}
                        onItemClick={onItemClick}
                        aria-multiselectable={false}
                    />
                </div>
            </div>
        </>
    );
}

export default TreeViewGA;